export enum RoleName {
  SUPER_ADMIN = "Super Admin",
  WASA_ADMIN = "Wasa Admin",
  ADMIN = "Admin",
  PUMP_OPERATOR = "Pump Operator",
}

const normalizedRoleMap: Record<string, RoleName> = Object.values(RoleName).reduce(
  (acc, role) => {
    acc[role.toLowerCase()] = role;
    return acc;
  },
  {} as Record<string, RoleName>
);

export function normalizeRoleName(value?: string | null): RoleName | null {
  if (!value?.trim()) {
    return null;
  }
  return normalizedRoleMap[value.trim().toLowerCase()] ?? null;
}

export const elevatedPumpRechargeRoles: RoleName[] = [
  RoleName.SUPER_ADMIN,
  RoleName.WASA_ADMIN,
  RoleName.ADMIN,
];
